import React, { useEffect } from 'react'
import { PasswordFieldSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { editUserId, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@app"

export default function UserPasswordField() {

	const { password, setPasswordInfo } = useAdminUsersInfo(userPayload.peek()?.user?.password, "password", "user")

	// Required on create and Clone (Clone also sets editUserId); optional on Edit, where empty = unchanged.
	// Whenever something is typed, the same rules as the server apply (CU-869fkp7e8).
	const isEdit = !!editUserId.value && !userPayload.value?.clone
	const required = !isEdit

	const { errors, isValid } = useValidatorSeeker(
		{ password: password },
		object({
			...(required || !!password) && {
				password: passwordRules(required)
			}
		})
	)


	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), password: isValid }
	}, [isValid])

	return <PasswordFieldSeeker
		value={password}
		onChange={e => setPasswordInfo(e.target.value)}
		error={errors?.password}
		{...isEdit && { label: 'New password', helperText: errors?.password || EDIT_HELP }}
		inputProps={{ autoComplete: 'new-password' }}
	/>
}

const EDIT_HELP = 'Leave empty to keep the current password'
const MAX_PASSWORD_BYTES = 72

function passwordRules(required) {
	const rules = string()
		.min(8, 'Password must be at least 8 characters long')
		.matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
		.matches(/[a-z]/, 'Password must contain at least one lowercase letter')
		.matches(/\d/, 'Password must contain at least one number')
		.matches(/[@$!%*?&]/, 'Password must contain at least one special character: @ $ ! % * ? &')
		.test('max-bytes', 'Password must be at most 72 characters long',
			v => !v || new TextEncoder().encode(v).length <= MAX_PASSWORD_BYTES)
	return required ? rules.required('Must provide a password') : rules
}